import React, { useRef } from 'react';
import { Button } from 'primereact/button';

/**
 * Componente para subir imágenes desde el equipo
 */
const ImageUploadField = ({ value, onChange, label, showPreview = true }) => {
    const fileInputRef = useRef(null);

    const handleFileSelect = (event) => {
        const file = event.target.files[0];
        if (file) {
            if (file.type.startsWith('image/')) {
                onChange(file);
            } else {
                alert('Por favor seleccione un archivo de imagen válido');
            }
        }
    };

    const handleRemove = () => {
        onChange(null);
        if (fileInputRef.current) {
            fileInputRef.current.value = '';
        }
    };

    const getPreviewUrl = () => {
        if (value instanceof File) {
            return URL.createObjectURL(value);
        } else if (typeof value === 'string') {
            return value;
        }
        return null;
    };

    const previewUrl = getPreviewUrl();
 
    
    
    return (
        <div className="field">
            {label && <label>{label}</label>}
            <div style={{ marginTop: '0.5rem' }}>
                <input
                    ref={fileInputRef}
                    type="file"
                    accept="image/*"
                    onChange={handleFileSelect}
                    style={{ display: 'none' }}
                />
                <div style={{ display: 'flex', gap: '0.5rem', alignItems: 'center', flexWrap: 'wrap' }}>
                    <Button
                        type="button"
                        label={value ? 'Cambiar imagen' : 'Seleccionar imagen'}
                        icon="pi pi-upload"
                        onClick={() => fileInputRef.current?.click()}
                        className="p-button-outlined"
                    />
                    {value && (
                        <Button
                            type="button"
                            label="Eliminar"
                            icon="pi pi-times"
                            onClick={handleRemove}
                            className="p-button-outlined p-button-danger"
                        />
                    )}
                    {value && (
                        <span style={{ fontSize: '0.9rem', color: '#666' }}>
                            {value instanceof File ? value.name : 'Imagen cargada'}
                        </span>
                    )}
                </div>
                
                {showPreview && previewUrl && (
                    <div style={{ marginTop: '1rem' }}>
                        <img
                            src={typeof(value)=='string' ? `https://repo.sumaenlinea.mx/landing-talink/${previewUrl}` : previewUrl}
                            alt="Preview"
                            style={{
                                maxWidth: '200px',
                                maxHeight: '200px',
                                objectFit: 'contain',
                                border: '1px solid #ddd',
                                borderRadius: '4px'
                            }}
                        />
                    </div>
                )}
            </div>
        </div>
    );
};

export default ImageUploadField;
